<template>
    <div :class="['custom-range', 'custom-range-type-2', cssClass]">
        <label v-if="showLabel && $te(label)" :for="uniqueId" class="input-label">{{ $t(label) }}</label>
        <div class="range-inputs">
            <CustomInput
                :modelValue="minValue"
                :inputKey="`${inputKey}.min`"
                @update:modelValue="onMinInput"
                type='number'
                pattern="^[1-9]\d*$"
                :min="min"
                :max="max"
                :step="step"
                :showLabel="showLabelMinMax"
                :showError="false"
            />
            <CustomInput
                :modelValue="maxValue"
                :inputKey="`${inputKey}.max`"
                @update:modelValue="onMaxInput"
                type='number'
                pattern="^[1-9]\d*$"
                :min="min"
                :max="max"
                :step="step"
                :showLabel="showLabelMinMax"
                :showError="false"
            />
        </div>
        
        <p v-if="!inputError && showDescription && $te(description)" class="input-description">{{ $t(description) }}</p>
        <p v-if="inputError" class="input-error">{{ $te(error) ? $t(error) : $t('fields.default.range.error') }}</p>
    </div>
</template>

<script>
import { nextTick } from 'vue';
import CustomInput from '@/components/inputs/CustomInput';
import { formatNumber } from '@/utils/formatting';

export default {
    components: {
        CustomInput
    },
    props: {
        inputKey: String,
        modelValue: {
            type: Object,
            default: () => ({ min: '', max: '' })
        },
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 100
        },
        step: {
            type: Number,
            default: 1
        },
        cssClass: {
            type: String,
            required: false
        },
        required: {
            type: Boolean,
            default: false,
        },
        showLabel: {
            type: Boolean,
            default: true,
        },
        showDescription: {
            type: Boolean,
            default: true,
        },
        showLabelMinMax: {
            type: Boolean,
            default: false
        },
        formatLabelRange: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            inputError: false,
            label: `fields.${this.inputKey}.label`,
            error: `fields.${this.inputKey}.error`,
            description: `fields.${this.inputKey}.description`,
            uniqueId: `${this.inputKey}-${Math.random().toString(36).substr(2, 9)}`,
            minValue: this.modelValue.min,
            maxValue: this.modelValue.max && this.modelValue.max <= this.max ? this.modelValue.max : this.max
        };
    },
    methods: {
        formatNumber,
        onMinInput(value) {
            this.minValue = Number(value);
            this.updateModelValue();
        },
        onMaxInput(value) {
            this.maxValue = Number(value);
            this.updateModelValue();
        },
        updateModelValue() {
            nextTick(() => {
                if(this.validateInput()) {
                    this.$emit('update:modelValue', { min: this.minValue, max: this.maxValue });
                } else {
                    // Don't emit if values aren't valid
                }
            });
        },
        validateInput() {
            if (
                (this.minValue || this.min) > (this.maxValue || this.max) ||
                (this.minValue || this.min) < this.min || 
                (this.maxValue || this.max) > this.max ||
                (this.required && this.minValue === '' && this.maxValue === '')) {
                this.inputError = true;
            } else {
                this.inputError = false;
            }
            return !this.inputError;
        },
        triggerValidation() {
            return this.validateInput();
        }
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(newValue) {
                this.minValue = newValue.min || '';
                this.maxValue = newValue.max && newValue.max <= this.max ? newValue.max : '';
                this.inputError = false;
            }
        }
    },
};
</script>

